import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4 stats-box position-relative" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex justify-content-between" }
const _hoisted_4 = { class: "chart-position" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mb-35" }, [
          _createElementVNode("span", null, "Total Orders"),
          _createElementVNode("h3", { class: "fs-20 mt-1 mb-0" }, "$72,458")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isClient)
            ? (_openBlock(), _createBlock(_component_apexchart, {
                key: 0,
                type: "bar",
                height: "110",
                options: _ctx.totalOrders,
                series: _ctx.orders
              }, null, 8, ["options", "series"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "d-flex justify-content-between flex-wrap gap-2 align-items-center" }, [
        _createElementVNode("span", { class: "count up fw-medium ms-0" }, "+25%"),
        _createElementVNode("span", { class: "fs-12" }, "Last 90 days")
      ], -1))
    ])
  ]))
}